"use strict";
import $ from "jquery";
import _ from "underscore";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  pause: function(itemId, note, date, emailId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/exceptioned_items/" + itemId + "/pause", {
        note,
        review_on: date,
        email_id: emailId
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  pauseEmailMessage: function(emailMessageId, note, date) {
    return this._pause("email_messages/" + emailMessageId, note, date);
  },
  pauseDocumentGroup: function(documentGroupId, note, date) {
    return this._pause("document_groups/" + documentGroupId, note, date);
  },
  _pause: function(path, note, date) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/" + path + "/exceptioned_items/pause", {
        note,
        review_on: date
      }).then(function(data) {
        DataStoreService.updateStores(data);
      }, _.identity)
    );
  },
  clearActiveItem: function(itemId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/exceptioned_items/" + itemId + "/clear_active_item").then(
        function(data) {
          DataStoreService.updateStores(data);
          return data;
        },
        _.identity
      )
    );
  }
};
